/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_nA_110_65 as Componente_nA_110_65,
  rec_Componente_oA_111_65 as Componente_oA_111_65,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_iA as iA,
} from "../../runtime/index.jsx";
export function ColoresMarca(e) {
  let t = (0, ReactCompiler.c)(10),
    { f: n, setF: r, previa: i } = e,
    a;
  t[0] !== n || t[1] !== r
    ? ((a = iA.map((e) => (
        <div
          key={e.campo}
          className={`flex items-center gap-3`}
          children={[
            <input
              type={`color`}
              aria-label={e.label}
              value={n[e.campo]}
              onChange={(t) =>
                r({
                  ...n,
                  [e.campo]: t.target.value,
                })
              }
              className={`h-11 w-11 shrink-0 cursor-pointer rounded-xl border border-(--border) bg-(--bg) p-1`}
            />,
            <div
              className={`min-w-0 flex-1`}
              children={[
                <p className={`text-sm text-(--text-h)`} children={e.label} />,
                <p className={`text-xs text-(--text)`} children={e.ayuda} />,
              ]}
            />,
            <code className={`shrink-0 text-xs`} children={n[e.campo]} />,
          ]}
        />
      ))),
      (t[0] = n),
      (t[1] = r),
      (t[2] = a))
    : (a = t[2]);
  let o;
  t[3] === a
    ? (o = t[4])
    : ((o = <div className={`flex flex-col gap-3`} children={a} />),
      (t[3] = a),
      (t[4] = o));
  let s;
  t[5] === i
    ? (s = t[6])
    : ((s = <Componente_oA_111_65 previa={i} />), (t[5] = i), (t[6] = s));
  let c;
  return (
    t[7] !== o || t[8] !== s
      ? ((c = (
          <Componente_nA_110_65
            titulo={`Colores`}
            ayuda={`Elegí tres. El resto —el color del texto sobre cada uno— se calcula solo para que siempre se lea.`}
            children={[o, s]}
          />
        )),
        (t[7] = o),
        (t[8] = s),
        (t[9] = c))
      : (c = t[9]),
    c
  );
}
